import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useEffect, useRef } from 'react';

// This is a workaround for a known issue with react-leaflet where the default icon does not show up.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

function MapResizer() {
  const map = useMap();
  useEffect(() => {
    const invalidate = () => {
      try {
        if (map && typeof map.invalidateSize === 'function') {
          map.invalidateSize(true);
        }
      } catch (e) {
        console.warn("MapResizer error:", e);
      }
    };
    invalidate();
    const t1 = setTimeout(invalidate, 100);
    const t2 = setTimeout(invalidate, 400);

    let observer;
    if (map && map._container && window.ResizeObserver) {
      observer = new ResizeObserver(() => invalidate());
      observer.observe(map._container);
    }
    window.addEventListener('resize', invalidate);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      if (observer && map._container) observer.unobserve(map._container);
      window.removeEventListener('resize', invalidate);
    };
  }, [map]);
  return null;
}

const Map = ({ leads, selectedLead }) => {
  const markerRefs = useRef({});

  useEffect(() => {
    if (selectedLead && markerRefs.current[selectedLead.id]) {
      markerRefs.current[selectedLead.id].openPopup();
    }
  }, [selectedLead]);

  return (
    <MapContainer center={[52.2297, 21.0122]} zoom={13} style={{ minHeight: '400px', height: '100%', width: '100%' }}>
      <MapResizer />
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {Array.isArray(leads) && leads.map(lead => (
        lead.latitude && lead.longitude && (
          <Marker 
            key={lead.id} 
            position={[lead.latitude, lead.longitude]}
            ref={el => markerRefs.current[lead.id] = el}
          >
            <Popup>
              <b>{lead.companyName}</b><br />
              {lead.address}
            </Popup>
          </Marker>
        )
      ))}
    </MapContainer>
  );
};

export default Map;
